// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_12-2";
export var blackBorderOnHover = "_12-7";
export var cell = "_12-6";
export var cellContainer = "_12-3";
export var checked = "_12-8";
export var disabled = "_12-5";
export var featuredIconCellContainer = "_12-9";
export var featuredIconTextContainer = "_12-b";
export var featuredIconWrapper = "_12-a";
export var noBorder = "_12-c";
export var orangeSelectedRow = "_39-3";
export var overflowableText = "_12-0";
export var overflowableTextContainer = "_12-1";
export var row = "_16-0";
export var rowCheckboxCell = "_12-4";
export var selectableTable = "_39-2";